import { render, staticRenderFns } from "./MoveAgentChatModal.vue?vue&type=template&id=4b2419d4&"
import script from "./MoveAgentChatModal.vue?vue&type=script&lang=js&"
export * from "./MoveAgentChatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports